import cntl from "cntl";
import PropTypes from "prop-types";
import { useMemo, useState } from "react";
import { COLOR, SIZE } from "../constants";
import SectionContent from "./SectionContent";
import SectionItem from "./SectionItem";

const propTypes = {
  theme: PropTypes.oneOf(["", COLOR.dark, COLOR.grey, COLOR.light, COLOR.primary, COLOR.primary_light]),
};

function FeatureSimpleIcons02({ items, theme, content }) {
  const [bgColor, setBgColor] = useState("");

  const wrapperCn = () => cntl`
    ${bgColor}
  `;

  const containerCn = () => cntl`
    container
    px-4 md:px-8 py-16 md:py-24
    gap-y-12
    lg:gap-x-16
    flex
    justify-center
    flex-columns
    mx-auto
  `;

  const columnsWrapperCn = () => cntl`
    grid
    grid-cols-1
    md:grid-cols-3
    gap-y-10
    gap-x-0
    md:gap-x-16
    max:gap-y-8
  `;

  useMemo(() => {
    switch (theme) {
      case "dark":
        setBgColor("bg-grey-800");
        break;
      case "grey":
        setBgColor("bg-grey-50");
        break;
      case "primary":
        setBgColor("bg-primary-800");
        break;
      case "primaryLight":
        setBgColor("bg-primary-50");
        break;
      case "light":
        setBgColor("bg-white");
        break;
      default:
        break;
    }
  }, [theme]);

  return (
    <div className={wrapperCn()}>
      <div className={containerCn()}>
        {content && <SectionContent {...content} />}
        <div className={columnsWrapperCn()}>
          {items?.map((item, index) => {
            return (
              <div key={`simple-icon-item-${index}`}>
                <SectionItem {...item} />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

FeatureSimpleIcons02.prototype = propTypes;
export default FeatureSimpleIcons02;
